import { render, staticRenderFns } from "./FileSignList.vue?vue&type=template&id=6664ef1d&"
import script from "./FileSignList.vue?vue&type=script&lang=js&"
export * from "./FileSignList.vue?vue&type=script&lang=js&"
import style0 from "./FileSignList.vue?vue&type=style&index=0&id=6664ef1d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports